'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _compose = require('lodash/fp/compose');

var _compose2 = _interopRequireDefault(_compose);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Represents a resource which has side effect.
 * Functor to record the operations and explicit do side effect tasks.
  * */
var IO = function () {
  _createClass(IO, null, [{
    key: 'of',
    value: function of(v) {
      return new IO(function () {
        return v;
      });
    }

    /**
     * Explicit execute the side effect, the recorded operations will execute one by one with the
     * parameter returned by previous operation.
      * */

  }]);

  function IO(wrapper) {
    _classCallCheck(this, IO);

    this.unsafePerformIO = wrapper;
  }

  /**
   * Record the operation without execute it.
    * */


  _createClass(IO, [{
    key: 'map',
    value: function map(f) {
      return new IO((0, _compose2.default)(f, this.unsafePerformIO));
    }
  }]);

  return IO;
}();

exports.default = IO;